import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2072 6.20718L6.20718 19.2072L4.79297 17.793L17.793 4.79297L19.2072 6.20718Z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.7928 19.2072L4.79282 6.20718L6.20703 4.79297L19.207 17.793L17.7928 19.2072Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol